import React, { useState, useEffect } from 'react';
import {
  Typography,
  Form,
  Select,
  notification,
  Input,
  Row,
  Col,
  Space,
  Alert,
  Card,
  Skeleton,
  Layout,
  Descriptions,
} from 'antd';
import Checkbox from 'antd/lib/checkbox/Checkbox';

import CustomButton from '../../../components/CustomButton';
import INTERNAL_LINKS from '../../../enums/InternalLinks';
import MESSAGES from '../../../enums/Messages';
import BreadcrumbContainer from '../../../containers/Breadcrumb';
import { get as getResume } from '../../../api/module/contractor';
import {
  put,
  get,
  announcementInfo,
} from '../../../api/module/announcement_selection';
import { useParams } from 'react-router-dom';

const { Title } = Typography;
const { TextArea } = Input;
const { Content } = Layout;

const AnnouncementSelectionValidationTests = ({ history }) => {
  const { announcement_id, announcement_rol_id, selection_id, person_id } =
    useParams();
  const [info, setInfo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loadingForm, setLoadingForm] = useState(true);
  const [initialValues, setInitialValues] = useState(null);
  const [resumeData, setResumeData] = useState('');
  const [name, setName] = useState('');

  const optionPreselection = [
    { id: 24, nombre: 'Pendiente' },
    { id: 25, nombre: 'Cumple' },
    { id: 26, nombre: 'No cumple' },
  ];

  const optionTest = [
    { id: 1, nombre: 'Aprueba' },
    { id: 2, nombre: 'No aprueba' },
  ];

  const breadcrumbItems = [
    {
      text: 'Selección',
      to: `${INTERNAL_LINKS.ANNOUNCEMENT_SELECTION}`,
    },
    {
      text: 'Validación',
      to: `${INTERNAL_LINKS.ANNOUNCEMENT_SELECTION_VALIDATION}/${announcement_id}/${announcement_rol_id}`,
    },
    {
      text: 'Validación estado pruebas',
    },
  ];

  const back = () => {
    history.push(
      `${INTERNAL_LINKS.ANNOUNCEMENT_SELECTION_VALIDATION}/${announcement_id}/${announcement_rol_id}`,
    );
  };

  const onFinish = async (data) => {
    try {
      setLoading(true);
      initialValues.resultado_prueba_especifica =
        data.resultado_prueba_especifica;
      initialValues.observacion_prueba_especifica =
        data.observacion_prueba_especifica;
      initialValues.resultado_entrevista = data.resultado_entrevista;
      initialValues.observacion_entrevista = data.observacion_entrevista;
      initialValues.resultado_prueba_sicotecnica =
        data.resultado_prueba_sicotecnica;
      initialValues.observacion_prueba_sicotecnica =
        data.observacion_prueba_sicotecnica;
      initialValues.resultado_final = data.resultado_final;

      const response = await put(selection_id, initialValues);
      if ([200, 201, 204].indexOf(response.status) > -1) {
        notification.success({
          message: MESSAGES.SUCCESS_MSG,
          description: MESSAGES.DESC_SUCCESS_MSG,
          duration: 2,
        });
        setTimeout(() => {
          history.push(
            `${INTERNAL_LINKS.ANNOUNCEMENT_SELECTION_VALIDATION}/${announcement_id}/${announcement_rol_id}`,
          );
          setLoading(false);
        }, MESSAGES.TIME);
      }
    } catch (err) {
      console.log(err);
      notification.error({
        message: MESSAGES.ERROR_MSG,
        description: MESSAGES.DESC_ERROR_POST_MSG,
        duration: 2,
      });
      setLoading(false);
    }
  };

  const getResumeData = async () => {
    const response = await getResume(person_id);
    setResumeData(response.data);
  };

  useEffect(() => {
    getName();
    getAnnouncement();
    getSelection();
    getResumeData();
  }, []);

  const getAnnouncement = async () => {
    try {
      const { data: aData } = await announcementInfo(announcement_rol_id);
      setInfo(aData);
      setLoadingForm(false);
    } catch (err) {
      console.log(err);
    }
  };

  const getSelection = async () => {
    try {
      const response = await get(selection_id);
      setInitialValues(response.data);
    } catch (err) {
      console.log(err);
    }
  };

  const getName = async () => {
    const response = await getResume(person_id);
    setName(
      `${response.data.numero_identificacion} - ${response.data.nombre_completo}`,
    );
  };

  const tailLayout = {
    labelCol: { span: 24 },
    wrapperCol: { span: 24 },
  };

  return (
    <Content>
      <BreadcrumbContainer items={breadcrumbItems} />
      <Title className={'text-uppercase'} level={2}>
        Módulo de Selección
      </Title>
      <Skeleton loading={loadingForm} active>
        {!!info ? (
          <Card
            size={'small'}
            bordered={false}
            title={
              <Title level={3}>Validación de estado de otras pruebas</Title>
            }
          >
            <Descriptions
              layout="vertical"
              title="Información de convocatoria"
              column={2}
              bordered
            >
              <Descriptions.Item label="Número de convocatoria">
                {info.convocatoria_numero}
              </Descriptions.Item>
              <Descriptions.Item label="Nombre de la convocatoria">
                {info.convocatoria_nombre}
              </Descriptions.Item>
              <Descriptions.Item label="Cargo/Rol">
                {info.cargo}
              </Descriptions.Item>
            </Descriptions>
            <br></br>
            <Descriptions
              layout="vertical"
              title="Información del contratista"
              column={2}
              bordered
            >
              <Descriptions.Item label="Nombre">
                {resumeData.nombre_completo}
              </Descriptions.Item>
              <Descriptions.Item label="Número de documento">
                {resumeData.numero_identificacion}
              </Descriptions.Item>
            </Descriptions>
          </Card>
        ) : null}

        {initialValues != null && initialValues.cargo_aplicado !== null && (
          <Alert
            style={{ marginBottom: 10 }}
            message="Atención"
            description={`El usuario también se encuentra aplicando al cargo ${initialValues.cargo_aplicado} de esta convocatoria.
            ¿Desea continuar con el proceso para este cargo?. En caso que no continúe, por favor rechazarlo.`}
            type="error"
            showIcon
          />
        )}
        <Card
          size={'small'}
          bordered={false}
          title={<Title level={3}>{name}</Title>}
        >
          {initialValues != null && info != null && (
            <Form
              onFinish={onFinish}
              initialValues={
                info.prueba_especifica !== 1 &&
                info.prueba_psicotecnica !== 1 &&
                initialValues.resultado_final == null
                  ? { ...initialValues, resultado_final: 25 }
                  : initialValues
              }
            >
              {info && info.prueba_especifica ? (
                <Content>
                  <Row gutter={12}>
                    <Col span={12}>
                      <Form.Item>
                        <Checkbox checked={info.prueba_especifica}>
                          Prueba específica
                        </Checkbox>
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        label="Resultado Prueba específica"
                        name="resultado_prueba_especifica"
                      >
                        <Select placeholder="Aprueba - No Aprueba">
                          {optionTest.map((item) => (
                            <Select.Option value={item.id}>
                              {item.nombre}
                            </Select.Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                  </Row>
                  <Form.Item
                    {...tailLayout}
                    name="observacion_prueba_especifica"
                    label="Observación"
                  >
                    <TextArea rows={4} />
                  </Form.Item>
                </Content>
              ) : null}
              {info && info.entrevista ? (
                <Content>
                  <Row gutter={12}>
                    <Col span={12}>
                      <Form.Item>
                        <Checkbox checked={info.entrevista}>
                          Entrevista
                        </Checkbox>
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        label="Resultado Entrevista"
                        name="resultado_entrevista"
                      >
                        <Select placeholder="Aprueba - No Aprueba">
                          {optionTest.map((item) => (
                            <Select.Option value={item.id}>
                              {item.nombre}
                            </Select.Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                  </Row>
                  <Form.Item
                    {...tailLayout}
                    name="observacion_entrevista"
                    label="Observación"
                  >
                    <TextArea rows={4} />
                  </Form.Item>
                </Content>
              ) : null}
              {info && info.prueba_psicotecnica ? (
                <Content>
                  <Row gutter={12}>
                    <Col span={12}>
                      <Form.Item>
                        <Checkbox checked={info.prueba_psicotecnica}>
                          Prueba psicotécnica
                        </Checkbox>
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        label="Resultado Prueba psicotécnica"
                        name="resultado_prueba_sicotecnica"
                      >
                        <Select placeholder="Aprueba - No Aprueba">
                          {optionTest.map((item) => (
                            <Select.Option value={item.id}>
                              {item.nombre}
                            </Select.Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                  </Row>
                  <Form.Item
                    {...tailLayout}
                    name="observacion_prueba_sicotecnica"
                    label="Observación"
                  >
                    <TextArea rows={4} />
                  </Form.Item>
                </Content>
              ) : null}
              {info.prueba_especifica === null &&
                info.entrevista === null &&
                info.prueba_psicotecnica === null &&
                'No hay requerimientos técnicos para registrar'}
              <Content style={{ marginTop: 20 }}>
                <Row gutter={12}>
                  <Col span={24}>
                    <Form.Item
                      name="resultado_final"
                      label="Resultado final"
                      rules={[
                        {
                          required: true,
                        },
                      ]}
                    >
                      <Select disabled={initialValues.estado_seleccion === 21}>
                        {optionPreselection.map((item) => (
                          <Select.Option
                            key={`status-key-${item.id}`}
                            value={item.id}
                          >
                            {item.nombre}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
              </Content>
              <Space>
                {initialValues.estado_seleccion !== 21 && (
                  <CustomButton loading={loading} text="Guardar" />
                )}
                <CustomButton
                  type={'default'}
                  className={'back-button'}
                  htmlType="button"
                  onClick={back}
                  text="Volver"
                />
              </Space>
            </Form>
          )}
        </Card>
      </Skeleton>
    </Content>
  );
};

export default AnnouncementSelectionValidationTests;
